import { Box, Heading, HStack, Img, Text} from "@chakra-ui/react";

export const Homerepair = () => {
  return (
    <Box textAlign={"center"} mt={"20px"} pt={"50px"} mb={"20px"} pb={"20px"} bgColor={"white"}>
      <Heading>Home Repairs</Heading>
      <HStack width={"60%"} margin={"auto"} mt={"16vh"} gap={"20px"}>
        <Box alignItems={"center"} width={"23%"}>
          <Img
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/bigpictures/carpenter.jpg"
            }
            borderRadius={"5px"}
            width={"100%"}
            height={"15vh"}
          />
          <Text width={"100%"} fontSize={"0.89em"}>
            Furniture Making , Upholstery & Polish
          </Text>
        </Box>
        <Box alignItems={"center"} width={"23%"}>
          <Img
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/home_screen/carpenter.jpg"
            }
            h={"15vh"}
            borderRadius={"5px"}
            width={"90%"}
          />
          <Text>Carpenters</Text>
        </Box>
        <Box alignItems={"center"} width={"23%"}>
          <Img
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/category_v2/category_a91b73d0.jpeg"
            }
            h={"15vh"}
            borderRadius={"5px"}
            width={"90%"}
          />
          <Text>Electrecians</Text>
        </Box>
        <Box alignItems={"center"} width={"23%"}>
          <Img
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/home_screen/plumber.jpg"
            }
            h={"15vh"}
            borderRadius={"5px"}
            width={"90%"}
          />
          <Text>Plumbers</Text>
        </Box>
      </HStack>
    </Box>
  );
};
